"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerSearchInput = styled_components_1.default.input `
  height: 22px;
  width: 450px;
  font-size: 18px;
`;
//# sourceMappingURL=search-input.js.map